import { ThunderboltTwoTone } from '@ant-design/icons';
import { Flex } from 'antd';
import { DateTime } from 'luxon';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useRelayEnvironment } from 'react-relay';

import { ItemFragment$data } from '../../../package/src/graphql/__generated__/ItemFragment.graphql';
import { COLOR_BACKGROUND_TASK, FORMAT_DATE_DISPLAY_DAY_SHORT2, FORMAT_TIME_DISPLAY } from '../../const';
import { getObjectFromRelayStoreById } from '../../functions';
import { ComponentsDispatch } from '../../store';
import { setterCalendar } from '../../store/slices/calendarSlice';
import { TaskBoardTaskAssignee } from '../../taskBoard/component/taskBoardTaskAssignee';
import { ItemTaskType } from '../../types';

interface IDrawerPanelTask {
    task: ItemTaskType;
}

const DrawerPanelTask: React.FC<IDrawerPanelTask> = ({ task }) => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const environment = useRelayEnvironment();

    const status = task.status
        ? getObjectFromRelayStoreById<ItemFragment$data>(environment, `${task.status}`)
        : undefined;

    return (
        <Flex
            gap={10}
            align={'center'}
            key={task.id}
            onClick={() => {
                dispatch(setterCalendar({ currentTask: task }));
            }}
            style={{
                padding: 5,
                backgroundColor: COLOR_BACKGROUND_TASK,
                borderRadius: 8,
                paddingLeft: 10,
                cursor: 'pointer',
                marginBottom: 5,
            }}
        >
            <ThunderboltTwoTone style={{ backgroundColor: 'white', padding: 5, borderRadius: '50%', fontSize: 24 }} />
            <Flex vertical flex={1} style={{ fontSize: 13 }}>
                <div style={{ fontWeight: 'bold' }}>{task.name}</div>
                <Flex justify={'space-between'}>
                    <div>#{task.number}</div>
                    <div>{status?.name}</div>
                </Flex>
            </Flex>
            <TaskBoardTaskAssignee userId={task.owner_task_id} />
            <Flex vertical justify={'space-between'} style={{ fontSize: 13, paddingRight: 10 }} align={'end'}>
                <div>{DateTime.fromSQL(task.datetime).toFormat(FORMAT_DATE_DISPLAY_DAY_SHORT2)}</div>
                <div style={{ fontWeight: 'bold' }}>
                    {DateTime.fromSQL(task.start_datetime).toFormat(FORMAT_TIME_DISPLAY)}
                </div>
            </Flex>
        </Flex>
    );
};

export default DrawerPanelTask;
